<template>
	<div class="home">
		<a-breadcrumb>
			<a-breadcrumb-item href="">
				<a-icon type="home" />
			</a-breadcrumb-item>
			<a-breadcrumb-item href="">
				<a-icon type="desktop" />
				<span>监控功能</span>
			</a-breadcrumb-item>
			<a-breadcrumb-item> 现金流转管理 </a-breadcrumb-item>
		</a-breadcrumb>

		<div class="search-list-box">
			<a-form class="ant-advanced-search-form">
				<a-row :gutter="24">
					<a-col :span="6">
						<a-form-item :label="`所属银行：`">
							<a-tree-select style="width: 100%" placeholder="请选择银行" v-model="searchData.bank_id"
								:dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" allow-clear
								:tree-data="bankTreeData">
								<span v-if="key == '0'" slot="title" slot-scope="{ key, value }">
									请选择银行类型
								</span>
							</a-tree-select>
						</a-form-item>
					</a-col>

					<a-col :span="6">
						<a-form-item :label="`网点名称：`">
							<a-select style="width: 120px" show-search option-filter-prop="children" :filter-option="filterOption" v-model="searchData.node_id"
								placeholder="请选择网点名称">
								<a-select-option v-for="item in outletsList" :value="item.node_id"> {{item.name}}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item :label="`交易时间：`">
							<a-range-picker :disabledDate="disabledDate" :ranges="{ '今天': [moment(), moment()] }"
								:key="pickerKey" :placeholder="['交易开始时间', '交易结束时间']" @change="handleChangeDate"
								style="width: 120px" format="YYYY-MM-DD" />
						</a-form-item>
					</a-col>
					<a-col :span="6">
						<a-form-item :label="`交易结果：`">
							<a-select style="width: 100%" placeholder="请选择交易结果" v-model="searchData.status">
								<a-select-option :value="1">
									交易成功
								</a-select-option>
								<a-select-option :value="2">
									交易失败
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>

					<a-col :span="6">
						<a-form-item :label="`交易类型：`">
							<a-select style="width: 120px" v-model="searchData.type" placeholder="请选择交易类型">
								<a-select-option v-for="(item, index) in typeList" :value="index" :key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="6" :style="{
              textAlign: 'left',
              paddingLeft: '25px',
              marginTop: '6px',
            }">
						<a-button type="primary" @click="getList"> 查询 </a-button>
						<a-button :style="{ marginLeft: '8px' }" @click="handleReset">
							重置
						</a-button>
					</a-col>
				</a-row>
			</a-form>
			<div class="search-result-list">

				<div class="table-header-box">
					<div class="left">
						<h3 class="title">现金流转列表</h3>
					</div>
					<div class="right">
						<a-button type="primary" class="marginr20" @click="dow">
							导出Excel
						</a-button>
						<a-button type="primary" class="marginr20" @click="showDetail">
							详情
						</a-button>
					</div>
				</div>
				<a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
					:columns="columns" @change="handleTableChange" :pagination="{total: total_page * 10,
    showTotal: (total, range) => `共 ${total_page} 页 ${total_count} 条，总金额：${total_amount}`,}" :data-source="list"
					:scroll="{ x: 1200 }" rowKey="tran_id" size="small">
					<span slot="date" slot-scope="date, info">
						{{info.province}} {{info.city}}
					</span>
				</a-table>
			</div>
		</div>


		<a-modal v-model="detailShow" width="800px" title="详细信息" :footer="null">
			<a-spin :spinning="detailLoading">
				<a-table :columns="columns1" :key="editIndex" :pagination="{total: total_detail_page * 10}"
					:data-source="detailList" rowKey="id" size="small">

				</a-table>
				<div class="model-footer">
					<div class="left">
						<a-button type="primary" class="marginr20" html-type="submit" @click="detailShow = false">
							取消
						</a-button>
					</div>
					<div class="right">
						<a-button type="dashed" :disabled="isEditBtn('prev')" @click="editToData('prev')" class=""
							html-type="submit">
							上一条
						</a-button>
						<a-button type="dashed" :disabled="isEditBtn('next')" @click="editToData('next')"
							class="marginr20" html-type="submit">
							下一条
						</a-button>
					</div>
				</div>
			</a-spin>
		</a-modal>


		<a-modal v-model="downModalShow" width="400px" title="导出Excel" :okText="confirmLoading ? '正在导出...' : '导出'"
			@ok="cityDateDown" :confirmLoading="confirmLoading">
			<div style="min-height: 200px;">
				<p>地区:</p>
				<a-cascader :options="cityList" style="width: 100%;" placeholder="请选择地区" @change="onCityChange" />
				<p style="margin-top: 20px;">月份：</p>
				<a-range-picker v-model="downForm.date" format="YYYY-MM-DD HH:mm:ss" />
				<!-- <a-month-picker v-model="downForm.date" format="YYYY-MM" style="width: 100%;" placeholder="请选择月份"/> -->
			</div>
		</a-modal>

	</div>
</template>

<script>
	import moment from 'moment';
	import http from '../http'

	const columns = [{
			title: "设备编号",
			dataIndex: "number",
			key: "1"
		},
		{
			title: "所属银行",
			dataIndex: "bank_name",
			key: "4"
		},
		{
			title: "网点名称",
			dataIndex: "node_name",
			key: "5"
		},
		{
			title: "厂商",
			dataIndex: "factory",
			key: "511"
		},

		{
			title: "交易流水号",
			dataIndex: "trade_no",
			key: "19"
		},

		{
			title: "交易类型",
			dataIndex: "type_name",
			key: "19"
		},

		{
			title: "交易时间",
			dataIndex: "add_time",
			key: "27"
		},
		{
			title: "金额",
			dataIndex: "amount",
			key: "28"
		},
	];
	const columns1 = [{
			title: "类型",
			dataIndex: "type_name",
			key: "28"
		},
		{
			title: "面值",
			dataIndex: "dename",
			key: "218"
		},
		{
			title: "数量",
			dataIndex: "count",
			key: "228"
		},
		{
			title: "总金额",
			dataIndex: "amount",
			key: "238"
		}
	]

	export default {
		data() {
			return {
				expand: false,
				columns,
				columns1,

				detailShow: false,

				info: {
					name: ''
				},

				searchData: {
					page: 1,
					number: '',
					bank_id: undefined,
					node_id: undefined,
					status: undefined,
					type: undefined,
					start_date: '',
					end_date: ''
				},
				typeList: ['全部', '硬币兑纸币', '纸币兑硬币', '纸币兑整零', '纸币整兑零'],
				list: [],
				total_page: 0,
				total_count: 0,
				total_amount: 0,

				// 表格选择的数据, 存储的是id
				selectedRowKeys: [],
				// 存储的是数据
				selectedRowDataList: [],
				// 当前是第几条编辑信息
				editIndex: 0,

				detailLoading: false,

				detailList: [],
				total_detail_page: 0,


				bankTreeData: [],
				outletsList: [],

				pickerKey: Math.random(),


				downModalShow: false,
				cityList: [],
				downForm: {
					city: '',
					province: '',
					date: ''
				},
				confirmLoading: false
			};
		},
		mounted() {
			this.getList()
			http({
				method: 'post',
				url: '/api.bank.area.list/',
				data: {}
			}).then((res) => {
				if (res.code == '200') {
					let cityData = {}
					res.data.forEach((v) => {
						if (cityData[v.province]) {
							cityData[v.province].children = [...cityData[v.province].children, {
								value: v.city,
								label: v.city,
							}]
						} else {
							cityData[v.province] = {
								children: [{
									value: v.city,
									label: v.city,
								}]
							}
						}
					})
					let newCityList = []
					for (let key in cityData) {
						newCityList.push({
							value: key,
							label: key,
							children: cityData[key].children
						})
					}
					this.cityList = newCityList
				} else {
					this.$message.error(res.data);
				}
			})
		},
		created() {
			this.getOutletsList()
			this.getBankTreeData()
		},
		methods: {
			moment,
			disabledDate(current) {
				return current && current >= moment().subtract("days"); //当天之前的不可选，不包括当天
				//return current && current < moment().endOf(‘day’);当天之前的不可选，包括当天
			},
			onCityChange(e) {
				this.downForm.province = e[0]
				this.downForm.city = e[1]
			},
			cityDateDown() {
				if (!this.downForm.province) {
					this.$message.error('请选择地区');
					return
				}
				if (!this.downForm.date || this.downForm.date.length != 2) {
					this.$message.error('请选择月份');
					return
				}
				if (this.confirmLoading) {
					return
				}
				this.confirmLoading = true
				http({
					method: 'post',
					url: '/api.transaction.export.trans/',
					data: {
						city: this.downForm.city,
						province: this.downForm.province,
						// date: this.downForm.date ? this.moment(this.downForm.date).format('YYYY-MM') : '',
						start_time: this.moment(this.downForm.date[0]).format("YYYY-MM-DD HH:mm:ss"),
						end_time: this.moment(this.downForm.date[1]).format("YYYY-MM-DD HH:mm:ss"),
					}
				}).then((res) => {
					if (res.code == 200) {
						window.open(res.data)
						setTimeout(() => {
							this.confirmLoading = false
							this.downModalShow = false
						}, 200)
					} else {
						this.confirmLoading = false
						this.$message.error(res.message);
					}
				})
			},
			dow() {
				this.downModalShow = true
			},
			handleReset() {
				this.pickerKey = Math.random()
				this.searchData = {
					page: 1,
					number: '',
					bank_id: undefined,
					node_id: undefined,
					status: undefined,
					type: undefined,
					start_date: '',
					end_date: ''
				}
				this.getList();
			},

			handleSelectChange(value) {
				console.log(value);
				this.form.setFieldsValue({
					note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,
				});
			},

			// 日期解析
			handleChangeDate(date) {
				this.searchData.start_date = this.moment(date[0]).format('YYYY-MM-DD')
				this.searchData.end_date = this.moment(date[1]).format('YYYY-MM-DD')
			},

			// 认证通过 
			tocheck() {
				// 判断是否已经选择数据
				if (this.selectedRowKeys.length == 0) {
					this.$message.warning('请先选择角色');
					return
				}
				this.$confirm({
					title: '是否认证审核选中用户?',
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk: () => {
						let selectDatas = this.selectedRowKeys
						http({
							method: 'post',
							url: '/api.user.tocheck/',
							data: {
								user_id: selectDatas.join(),
								status: 1
							}
						}).then((res) => {
							if (res.code == '200') {
								this.$message.success('用户认证审核成功');
								this.getList()
							} else {
								this.$message.error(res.data);
							}
						})
					}
				});
			},
			//删除
			deleteUser() {
				// 判断是否已经选择数据
				if (this.selectedRowKeys.length == 0) {
					this.$message.warning('请先选择用户');
					return
				}
				this.$confirm({
					title: '是否删除选中用户?',
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk: () => {
						let selectDatas = this.selectedRowKeys
						http({
							method: 'post',
							url: '/api.transaction.count/',
							data: {
								user_id: selectDatas.join(),
							}
						}).then((res) => {
							if (res.code == '200') {
								this.$message.success('删除用户成功');
								this.getList()
							} else {
								this.$message.error(res.data);
							}
						})
					}
				});
			},
			// 表格分页
			handleTableChange(pagination, filters, sorter) {
				console.log(pagination, filters, sorter)
				this.searchData.page = pagination.current
				this.getList();
			},
			// 表格选择
			onSelectChange(selectedRowKeys) {
				console.log('selectedRowKeys changed: ', selectedRowKeys);
				this.selectedRowKeys = selectedRowKeys;
			},
			// 列表
			getList() {
				http({
					method: 'post',
					url: '/api.transaction.list/',
					data: {
						...this.searchData,
						bank_id: this.searchData.bank_id || 0,
						node_id: this.searchData.node_id || 0,
						status: this.searchData.status || 0,
						type: this.searchData.type || 0
					}
				}).then((res) => {
					this.list = res.data.list
					this.total_page = res.data.total_page
					this.total_count = res.data.total_count
					this.total_amount = res.data.total_amount
				})
			},
			// 日期解析
			handleChangeDate(date) {
				this.searchData.start_date = this.moment(date[0]).format('YYYY-MM-DD')
				this.searchData.end_date = this.moment(date[1]).format('YYYY-MM-DD')
			},

			showDetail() {
				// 判断是否已经选择数据
				if (this.selectedRowKeys.length == 0) {
					this.$message.warning('请先选择数据');
					return
				}
				console.log(this.selectedRowKeys)
				let selectDatas = []
				this.list.forEach((v) => {
					if (this.selectedRowKeys.includes(v.tran_id)) {
						selectDatas.push(v)
					}
				})
				this.selectedRowDataList = JSON.parse(JSON.stringify(selectDatas))
				console.log(this.selectedRowDataList)
				this.editIndex = 0
				// 获取文章详情
				this.getDetail()
				this.detailShow = true
			},
			// 详情
			getDetail() {
				this.detailLoading = true
				this.info = this.selectedRowDataList[this.editIndex]
				http({
					method: 'post',
					url: '/api.transaction.detail/',
					data: {
						tran_id: this.selectedRowDataList[this.editIndex].tran_id,
						page: 1
					}
				}).then((res) => {
					this.detailList = res.data
					this.detailLoading = false
				})
			},
			// 点击上一条 或者 下一条、
			editToData(type) {
				let index = -1
				if (type == 'prev') {
					index = this.editIndex - 1
					if (index == 0) {
						index = 0
					}
				} else if (type == 'next') {
					index = this.editIndex + 1
				}
				this.editIndex = index
				this.getDetail()
			},
			// 判断是否可以点击上一条 或者 下一条、
			isEditBtn(type) {
				if (type == 'prev') {
					if (this.editIndex == 0) {
						return true
					}
					if (this.selectedRowDataList == 1) {
						return true
					}
					if (this.editIndex >= 1) {
						return false
					}
				} else if (type == 'next') {
					if ((this.selectedRowDataList.length - 1) == this.editIndex) {
						return true
					}
				}
			},
			// 获取网点
			getOutletsList() {
				http({
					method: 'post',
					url: '/api.bank.node.treelist/',
					data: {
						band_id: 0
					}
				}).then((res) => {
					this.outletsList = res.data
				})
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			// 获取银行类型
			getBankTreeData() {
				http({
					method: 'post',
					url: '/api.bank.list/',
					data: {
						page: 1,
						parent_id: 0
					}
				}).then((res) => {
					this.bankTreeData = this.dataDealwith(res.data)
					console.log(this.bankTreeData)
				})
			},
			dataDealwith(treeData) {
				function setGrayNode(data) { //遍历树  获取id数组
					for (var i = 0; i < data.length; i++) {
						data[i] = {
							value: data[i].bank_id,
							key: data[i].bank_id,
							title: data[i].name,
							children: data[i].list || []
						} //子节点传给另一个函数专门用来改数据
						if (data[i].children && data[i].children.length) { // 如果当前节点有子节点，就递归调用一次
							setGrayNode(data[i].children);
						}
					}
				}

				setGrayNode(treeData)
				console.log(treeData)
				return treeData;
			},
		},
	};
</script>
<style>
	.ant-advanced-search-form {
		padding: 24px;
		background: #fbfbfb;
		border: 1px solid #d9d9d9;
		border-radius: 6px;
	}

	.ant-advanced-search-form .ant-form-item {
		display: flex;
	}

	.ant-advanced-search-form .ant-form-item-control-wrapper {
		flex: 1;
	}

	.search-list-box .ant-form {
		max-width: none;
	}

	.search-list-box .search-result-list {
		margin-top: 16px;
		border: 1px dashed #e9e9e9;
		border-radius: 6px;
		background-color: #fafafa;
		min-height: 200px;
		text-align: center;
		padding-top: 80px;
	}

	.imgs {
		display: flex;
	}

	.imgs img {
		width: 140px;
		height: 200px;
	}
</style>